import {Component, inject, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import { VcsService } from '../../../services/vcs.service';
import { BaseComponent } from '../../../../components/base/base.component';
import { VcsAPIService } from '../../../services/vcs-api/vcs-api.service';
import { WmsDialogComponent } from '../../../../components/wms-dialog/wms-dialog.component';
import { WmsDialogHeaderComponent } from '../../../../components/wms-dialog-header/wms-dialog-header.component';
import { WmsDialogBodyComponent } from '../../../../components/wms-dialog-body/wms-dialog-body.component';
import { WmsDialogFooterComponent } from '../../../../components/wms-dialog-footer/wms-dialog-footer.component';
import { hideMsg, showMsg } from '@wms/app/vcs/utils/vcs-utils';
import { WmsMessageComponent } from '../../../../components/wms-message/wms-message.component';
import { WmsViewChangesTableComponent } from '../../wms-view-changes-table/wms-view-changes-table.component';
import { NotificationService} from '@wms/services';
import { IFileItem } from '@wms/app/vcs/interface/file-item';
import { FormsModule } from "@angular/forms";
import { replace } from "@wm/core";
import {TabsModule} from "ngx-bootstrap/tabs";
import {Router} from "@angular/router";

@Component({
  selector: 'wms-vcs-view-dialog',
  templateUrl: './wms-vcs-view-dialog.component.html',
  styleUrls: ['./wms-vcs-view-dialog.component.less'],
  standalone: true,
    imports: [
        CommonModule,
        WmsDialogComponent,
        WmsDialogHeaderComponent,
        WmsDialogBodyComponent,
        WmsDialogFooterComponent,
        WmsMessageComponent,
        WmsViewChangesTableComponent,
        FormsModule,
        TabsModule
    ],
})
export class WmsVcsViewDialogComponent extends BaseComponent implements OnInit {
  public vcsService: VcsService;
  private vcsAPIService: VcsAPIService;
  private notificationService: NotificationService
  router: Router;

  private filesToRevert: IFileItem[];
  restoreMessage = '';
  changesTypes:string;


  protected projectDetails: any;
  constructor() {
    super();
    this.vcsService = inject(VcsService);
    this.vcsAPIService = inject(VcsAPIService);
    this.notificationService = inject(NotificationService)
    this.router = inject(Router);
  }
  ngOnInit() {
      this.vcsService.selectedTab = 'My Changes';
  }

  handleFileFromChild(file:any,changesType:string) {
    this.changesTypes = changesType
    this.filesToRevert = file;
  }
  getSelectedTab(event:any){
    this.vcsService.selectedTab =event.heading;
  }

  revertFiles() {
    let filePathsToRevert: any = [];
    if (this.filesToRevert) {
      this.filesToRevert.forEach((item) => {
        if (item.isChecked ||  (item.files && item.files.some((file) => file.isChecked))) {
          if (item.files) {
            item.files.map((file: any) => {
              if (file.isChecked) {
                file['files'] = [];
                filePathsToRevert.push(file);
              }
            });
          }
          if(item.isChecked){
            filePathsToRevert.push(item)
          }
        }
      });

      if (filePathsToRevert.length === 0 || !filePathsToRevert) {
        this.vcsService.msgData = showMsg(this.locale['MESSAGE_VCS_NO_FILE_SELECTED'], 'error');
      } else {
        this.vcsService.msgData = hideMsg()
        this.vcsAPIService.revertChanges(filePathsToRevert,this.changesTypes).then((): void => {
            this.notificationService.show('success', '', this.locale['MESSAGE_VCS_REVERT_SUCCESS']);
            this.vcsService.closeDialogWithId('viewChangesModal');
          const pageWithAddedDiff = filePathsToRevert.some((item: any) =>
            item.groupType === 'PAGE' && item.vcsDiffType === 'ADDED'
          );

            if (pageWithAddedDiff) {
               this.reloadPage('Main')
            }else {
              window.location.reload()
            }
          }).catch((error) => {
            this.vcsService.msgData = showMsg(error.error.errors.error[0].message.replace('{0}', error.error.errors.error[0].parameters[0]),'error')
          });
      }
    } else {
      this.vcsService.msgData =  showMsg(this.locale['MESSAGE_VCS_NO_FILE_SELECTED'], 'error');
    }
  }

  reloadPage(pageName: string) {
    this.router.navigate(['page/' + pageName]);
    setTimeout(() => {
      window.location.reload();
    });
  }

  restoreToRemoteTrackingBranch() {
    this.vcsAPIService.restoreToRemoteTrackingBranch().then((response): void => {
      this.vcsService.closeDialogWithId('confirmRestoreToRTBDialog');
      window.location.reload();
    }, (error) => {
      this.vcsService.openDialogWithId('confirmRestoreToRTBDialog');
    });
  }

  openConfirmRestoreToRTBDialog() {
    const mergeRequestLabel = this.locale['LABEL_MERGE_REQUESTS_' + this.projectService.teamProjectObject.vcsAccountDTO.vcsAccountType] || this.locale.LABEL_MERGE_REQUESTS_DEFAULT;
    this.restoreMessage = replace(this.locale.MSG_RESTORE_TO_REMOTE_BRANCH, [mergeRequestLabel, this.projectService.teamProjectObject.vcsBranch]) || '';
    this.vcsService.openDialogWithId('confirmRestoreToRTBDialog');
  }

  closeDialog(){
    this.vcsService.closeDialogWithId('viewChangesModal')
    if(this.vcsService.reloadProject){
      this.vcsService.reloadProject = false
      window.location.reload()
    }
  }

  showMultipleTabs(): boolean {
    return this.hasChanges('MIGRATION_CHANGES_ON_LAST_PULLED') || this.hasChanges('USER_CHANGES_SINCE_LAST_PUSHED');
  }

  hasChanges(changesType: string): boolean {
    return this.vcsService.fileList?.changesTypeVsDiffEntriesMap[changesType]?.length;
  }

  getChanges(changesType: string): any[] {
    return this.vcsService.fileList?.changesTypeVsDiffEntriesMap[changesType];
  }

}
